import { entityIdsOf, entityMapOf } from "@/widgets/shared/utils/entity-utils";
import Constants from "@/widgets/shared/constants";

// Definition of fake "My Schedule" component
// Used to display user's scheduled sessions
const myScheduleComponent = {
  id: -1,
  component_name: "AgendaComponent",
  label: "Agenda / My Schedule",
  order: -1,
};

export function state() {
  return {
    ids: [],
    components: {},
    selectedId: null,
  };
}

export const mutations = {
  setComponents(state, components) {
    state.ids = entityIdsOf(components);
    state.components = entityMapOf(components);
  },

  selectById(state, id) {
    state.selectedId = id || null;
  },

  selectByIndex(state, index) {
    const id = state.ids[index];
    state.selectedId = id || null;
  },
};

export const actions = {
  async collectComponents({commit, dispatch, state, rootState}, {components, prependMySchedule}) {
    // Filter only for agenda components
    // eslint-disable-next-line prettier/prettier
    const agendaComponents = components
      .filter(component => isAgenda(component))
      .sort((a, b) => a.order - b.order);

    // Prepend the "My Schedule" fake component
    if (prependMySchedule) {
      agendaComponents.splice(0, 0, myScheduleComponent);
    }
    commit("setComponents", agendaComponents);

    // Find default agenda or first *real* agenda component
    if (state.selectedId === null || (!prependMySchedule && state.selectedId === -1)) {
      if(rootState.eventId === 1280 && prependMySchedule) {
        await dispatch("selectAgendaById", -1);
      } else {
        const defaultAgendaComponentId =
          components.find(component => component.additional_info.default_agenda).id || state.ids.find(id => id > 0);
        await dispatch("selectAgendaById", defaultAgendaComponentId);
      }
    } else {
      if(rootState.eventId === 1280 && prependMySchedule) {
        await dispatch("selectAgendaById", -1);
      }
      await dispatch("selectAgendaById", state.selectedId);
    }
  },

  async selectAgendaById({commit, dispatch, state}, componentId) {
    const agendaComponent = state.components[componentId];
    if (agendaComponent) {
      commit("selectById", componentId);
      if (componentId > 0) {
        await dispatch("sessions/loadSessions", {componentId: componentId, force: false}, {root: true});
      }
    }
  },

  async selectAgendaByIndex({state, commit, dispatch}, index) {
    const agendaComponentId = state.ids[index];
    if (agendaComponentId) {
      commit("selectById", agendaComponentId);
      if (agendaComponentId > 0) {
        dispatch("sessions/loadSessions", {componentId: agendaComponentId, force: false}, {root: true});
      }
    }
  },
};

export const getters = {
  componentById: state => id => state.components[id],

  allComponents(state, getters) {
    return state.ids.map(getters.componentById);
  },

  activeAgenda(state, getters) {
    const id = state.selectedId;
    return getters.componentById(id);
  },

  activeAgendaIndex(state) {
    const id = state.selectedId;
    return state.ids.indexOf(id);
  },

  activeAgendaRatings(state, getters) {
    return getters.activeAgenda && getters.activeAgenda.additional_info && getters.activeAgenda.additional_info.ratings_session;
  },
};

function isAgenda(component) {
  return component.component_name === Constants.AGENDA_COMPONENT_TYPE;
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
